import type { AgenticLogicRuleVersionDto } from "@intelligems/ig-types";

import type { WorkspaceVersion } from "@src/features/agenticCodegen/workspace/types";

/**
 * Version list DTO → the shell's structural version.
 *
 * One projection for both rule flavours: the code workspace and the template
 * rule's Advanced tab render the same cards, so a card learning a new field has
 * exactly one place to learn it.
 */
export const toWorkspaceVersion = (
  version: AgenticLogicRuleVersionDto
): WorkspaceVersion => ({
  id: version.id,
  version: version.version,
  status: version.status,
  publishedAtTs: version.publishedAtTs,
  publishedByUserId: version.publishedByUserId,
  // Resolved server-side at read time. Null when there is no publisher or the
  // id no longer resolves; the byline falls back to a label, never to the id.
  publishedByUser: version.publishedByUser,
  notes: version.notes,
  title: version.title,
  origin: version.origin,
  dependencyLockHash: version.dependencyLockHash,
});
